import React from 'react'
import ReactNumberFormat from 'react-number-format'

export default function NumberFormat(props: {
  children?: any
  format?: string
  showUnits?: boolean
  showZeros?: boolean
  value?: number
  currencySymbol?: string
}) {
  const { children, format, showUnits, showZeros, value = 0, currencySymbol = '$' } = props

  if (value || showZeros) {
    const numberFormatProps: any = {}
    numberFormatProps.decimalScale = 2
    numberFormatProps.thousandSeparator = true
    if (format === 'price') {
      if (showUnits) {
        numberFormatProps.prefix = currencySymbol
      }
      numberFormatProps.fixedDecimalScale = true
    }
    if (format === 'hours' && showUnits) {
      numberFormatProps.suffix = ' hr'
    }
    return <ReactNumberFormat {...numberFormatProps} value={value} displayType="text" />
  } else if (children) {
    return children
  } else {
    return <>{''}</>
  }
}
